import Image from 'next/image'
import {FC} from 'react'

import {useVideoContent} from '@/content/video'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'
import {analytics} from '@/utils/tracking/analytics'

import {VideoIframe} from '../../../video/VideoIframe'

type TrademarkRegistrationHeroVideoProps = {trackedEventParameters?: Record<string, string>}

export const TrademarkRegistrationHeroVideo: FC<TrademarkRegistrationHeroVideoProps> = ({
  trackedEventParameters,
}) => {
  const {url, background, thumbnail} = useVideoContent().trademarkRegistration

  return (
    <>
      <div className="video-wrapper">
        <div className="video-bg">
          <Image
            src={background.src}
            alt={background.alt}
            width={510}
            height={480}
            priority
            // the LCP element on narrow screens; `priority` alone preloads it at the default priority
            fetchPriority="high"
            style={{display: 'block', width: '100%', height: 'auto'}}
          />
        </div>
        <div className="video-preview">
          <VideoIframe
            src={url}
            thumbnail={thumbnail}
            sizes={`${MOBILE_SCREENSIZE} 100vw, 460px`}
            isPriority
            onClick={() =>
              analytics.track('Trademark registration video played', trackedEventParameters)
            }
            hasBoxShadow
          />
        </div>
      </div>

      <style jsx>{`
        .video-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: ${theme.spacing[5]};
          margin-right: -${theme.spacing[3]};
        }
        .video-bg {
          width: 500px;
          flex-shrink: 0;
        }
        .video-preview {
          position: absolute;
          width: 100%;
          height: 100%;
          max-width: 460px;
          max-height: 260px;
          margin-top: -38px;
          margin-right: -8px;
        }
        @media ${TABLET_SCREENSIZE} {
          .video-wrapper {
            margin-top: ${theme.spacing[7]};
            margin-left: 0;
            margin-right: 0;
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .video-wrapper {
            margin-top: ${theme.spacing[5]};
          }
          .video-bg {
            width: 100%;
          }
          .video-preview {
            margin-top: -20px;
            margin-right: 0;
            max-height: 240px;
          }
        }
      `}</style>
    </>
  )
}
